import * as React from 'react'
import ServiceHolidays from '../../../containers/services/ServiceHolidays'
import ServiceWorkingHours from '../../../containers/services/ServiceWorkingHours'
import { IHolidayItem, IStoreState, IWorkingHoursItem } from '../../../types/index'

interface IServiceDaysProps {
  formRef: any
  serviceId: any
  orgId: string
  isAllDaysActive: boolean
  workingHoursItems: { [key: number]: IWorkingHoursItem }
  holidayItems: { [key: number]: IHolidayItem }
  onComponentMount: (serviceId: string, orgId: string) => void
  onUpdateServiceDays: (
    serviceId: string,
    isAllDaysActive: boolean,
    workingHoursItems: IWorkingHoursItem[],
    holidaysItems: IHolidayItem[]
  ) => Promise<any>
  onStepSuccessfullyCompleted?: () => void
}

class ServiceDays extends React.Component<IServiceDaysProps, IStoreState> {
  constructor(props: IServiceDaysProps) {
    super(props)
  }

  public componentDidMount() {
    this.props.onComponentMount(this.props.serviceId, this.props.orgId)
  }

  public render() {
    return (
      <div className='pl2 col-8 mb3'>
        <div ref={this.props.formRef} onClick={this.handleSubmit} />
        <div className='font-dark-grey mt3'>Service Days & Hours</div>
        <ServiceWorkingHours />

        <div className='font-dark-grey mt3'>Holidays & Closures</div>
        <ServiceHolidays />
      </div>
    )
  }

  private handleSubmit = () => {
    const {
      serviceId,
      isAllDaysActive,
      workingHoursItems,
      holidayItems,
      onUpdateServiceDays,
      onStepSuccessfullyCompleted
    } = this.props

    onUpdateServiceDays(serviceId, isAllDaysActive, Object.values(workingHoursItems), Object.values(holidayItems)).then(
      () => onStepSuccessfullyCompleted && onStepSuccessfullyCompleted()
    )
  }
}

export default ServiceDays



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceDays.tsx